import React from 'react';

// Redux
import { connect } from 'react-redux';

export function authenticationChecker(Component) {
    class AuthenticationCheckerComponent extends React.Component {

        componentDidMount() {
            if(this.props.userId === null ||
               this.props.formId === null ||
               this.props.registrationRef === null) {
                   window.open(process.env.REACT_APP_OF_SITE_URL,"_self");
               }
        }

        render() {
            return (
                <Component {...this.props} /> 
            );
        }
    };

    const mapStateToProps = (state) => {
        return { 
            userId: state.authentication.userId,
            formId: state.authentication.formId,
            registrationRef: state.authentication.registrationRef
        } 
    };

    return connect(mapStateToProps, undefined)(AuthenticationCheckerComponent);
}